module.exports = "../images/fishing.jpg?v=25926cb";